import { render } from "./InputWithIcon.vue?vue&type=template&id=060d8ed0&scoped=true"
import script from "./InputWithIcon.vue?vue&type=script&lang=ts"
export * from "./InputWithIcon.vue?vue&type=script&lang=ts"

import "./InputWithIcon.vue?vue&type=style&index=0&id=060d8ed0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-060d8ed0"

export default script